import relativeDates from './relative-dates.mjs'

relativeDates()
